module.exports = __webpack_public_path__ + "static/media/GI.75202099.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GI.svg
// module id = 261
// module chunks = 0